import React from 'react';
import PropTypes from 'prop-types';
import CreatorButtons from 'SignatureManager/CreatorButtons';

const StaticBuilderSignatureManagerCreatorButtons = ({ useSignature, closeCreator }) => (
  <CreatorButtons
    addBtnData={{
      id: 'add-sig-btn',
      className: 'btn btn-success btn-large save-use-btn success-btn add-sig-btn',
      click: useSignature,
      text: 'Sign',
    }}
    cancelBtnData={{
      id: 'cancel-btn',
      className: 'btn btn-large save-use-btn cancel-btn',
      click: closeCreator,
      text: 'Cancel',
    }}
  />
);

StaticBuilderSignatureManagerCreatorButtons.propTypes = {
  useSignature: PropTypes.func.isRequired,
  closeCreator: PropTypes.func.isRequired,
};

export default StaticBuilderSignatureManagerCreatorButtons;



// WEBPACK FOOTER //
// ./src-react/StaticBuilder/StaticBuilderSignatureManager/CreatorButtons.jsx